'use strict';

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("App");

var $ = require("jquery");
var authorService = abp.services.api.author;

module.exports = exports.default = function () {
    $("#add-new-watchdog").attr("tabindex", "");

    $('#btn-add-watchdog-author-submit').off("click").on("click", function () {
        var authorId = $("#AuthorId").val();
        var customerId = $("#CustomerId").val();

        authorService.addWatchdog({
            AuthorId: authorId,
            CustomerId: customerId
        }).done(function (result) {
            $("#watchDogsAuthorGrid").DataTable().ajax.reload(null, false);
            _notify2.default.success(resx.App.WatchDogAdded);
        }).fail(function (result) {
            _notify2.default.error(result.responseJSON.exceptionMessage);
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/watchdogAuthor.js
// module id = 461
// module chunks = 0